import React, { useMemo } from 'react';
import { Stack, Typography } from '@mui/material';
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton,
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  XIcon,
} from 'react-share';
import { DynamicSocialShareLinksComponent } from '../../api/content';
import { RichText } from './RichText';

export const DynamicSocialShareLinks: React.FC<DynamicSocialShareLinksComponent> = ({
  title,
  url,
  description,
}) => {
  const shareUrl = useMemo(() => url || window.location.href, [url]);

  return (
    <Stack p={2} maxWidth={800} sx={{ margin: '0 auto !important' }}>
      {title && (
        <Typography variant="h3" component="h2" textAlign="center">
          {title}
        </Typography>
      )}
      {description && (
        <Stack sx={{ '& > *': { textAlign: 'center' } }}>
          <RichText content={description} />
        </Stack>
      )}
      <Stack direction="row" py={3} alignItems="center" justifyContent="center" spacing={2}>
        <EmailShareButton url={shareUrl}>
          <EmailIcon bgStyle={{ backgroundColor: 'primary.main' }} size={32} round />
        </EmailShareButton>
        <TwitterShareButton url={shareUrl}>
          <XIcon bgStyle={{ backgroundColor: 'primary.main' }} size={32} round />
        </TwitterShareButton>
        <LinkedinShareButton url={shareUrl}>
          <LinkedinIcon bgStyle={{ backgroundColor: 'primary.main' }} size={32} round />
        </LinkedinShareButton>
        <FacebookShareButton url={shareUrl}>
          <FacebookIcon bgStyle={{ backgroundColor: 'primary.main' }} size={32} round />
        </FacebookShareButton>
      </Stack>
    </Stack>
  );
};
